module.exports = __webpack_public_path__ + "img/mendian2.3f5ffab7.png";